<template lang='pug'>
v-dialog(scrollable max-width='400px' v-model='dialog' persistent lazy)
  v-card(class='combo-card')
    v-card-text(style='height: 300px')
      v-list
        v-radio-group(
          v-for='(item, index) in list'
          v-model='selected'
          :key='index'
        )
          v-list-tile
            v-list-tile-action
              v-radio(:value='item' :key='item.id' color='primary')
            v-list-tile-content
              v-list-tile-title {{ item.name }}
    v-card-actions
      v-spacer
      v-btn(@click='$emit("close")' flat) Отмена
      v-btn(
        flat
        :disabled='disabled'
        color='primary'
        @click='$emit("select", selected)'
      ) Ok
</template>

<script>
import http from '@/http'

export default {
  props: ['dialog'],

  data: () => ({
    selected: null,
    isLoading: false,
    list: []
  }),

  mounted() {
    if (this.dialog) {
      this.fetchList()
    }
  },

  methods: {
    async fetchList() {
      this.isLoading = true

      try {
        this.list = (await http.get('data/partners')).data
      } catch (e) {
        this.$showServerErrors(e)
      }

      this.isLoading = false
    }
  },

  computed: {
    disabled() {
      return !this.selected
    }
  },

  watch: {
    dialog(opened) {
      if (opened) {
        this.fetchList()
      } else {
        this.list = []
        this.selected = null
      }
    }
  }
}
</script>

<style scoped>
.combo-card {
  height: 100%;
}
</style>
